import React from "react";

const SectionOne = () => {
  return (
    <div className="section-one-container12 py-5">
      <div className="container " style={{ overflow: "hidden" }}>
        <div className="row mt-4 align-items-center">
          {/* LEFT: Image + Overlays */}
          <div className="col-12 col-lg-6 d-flex flex-column align-items-center position-relative  mb-lg-0">
            <div className="torn-image-background w-100 position-relative">
              <img
                style={{ maxHeight: "510px" }}
                src="./images/community patner.png"
                className="main-children-image img-fluid"
                alt="Children"
              />
              {/* <p className="always-support-text-exact position-absolute">
                Always Support <span className="text-dark">us</span>
              </p> */}
            </div>
            {/* <img
              src="./images/about-three-shape-1.png"
              alt="Red Heart"
              className="red-heart-drawing-heart position-absolute"
            />
            <img
              src="./images/Mask Group.png"
              alt="Decorative"
              className="red-heart-drawing-exact position-absolute "
            /> */}
          </div>

          {/* RIGHT: Text Section */}
          <div className="col-12 col-lg-6 d-flex flex-column right-column-border position-relative z-1 bg-white bg-opacity-75 p-4 rounded">
            <p className="about-us-subtitle-right-column">
              {/* <span className="about-us-line-dashed"></span> */}
            </p>
            <p className="always-support-text-exact  ">
              <span className="underline"> Community </span> Partner
            </p>
            <h2 className="share-circle-heading-left fw-bold">
              Community Support Partner <br />
              <span className="share-support-text">(CSP)</span>
            </h2>
            <p className="share-circle-subheading-left">
              Bitcoin Community Leaders & Share-Circle enable efficient,
              low-cost local lending
            </p>
            <ul className="share-circle-description-list-icon">
              {" "}
              {/* Renamed class for clarity */}
              <li>
                Community Support Partners can be small groups of local people
                who want to enable responsible local borrowing / lending / in
                your community.
              </li>
              <li>
                As a Bitcoin aware community leader, you understand the benefits
                of Bitcoin and lightning. You understand the needs of people in
                your community and have established relationships.
              </li>
              <li>
                We are on a mission to help Bitcoin communities grow. As Bitcoin
                aware Community Partners, (CSPs) you are central to the
                Share-Circle service. So, we see it as our job to help you. We
                see you in a similar way as UBER sees Taxi Drivers in their
                business – Motivated, self-employed, responsible people, who
                become local partners.
              </li>
              <li>
                We want to reward you for your time, and provide business
                support and training, to help you and your team to facilitate
                small business loans locally.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
